import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalOverviewIndexHandoff } from '@/pages/workspaces/transactional/message/overview/index-tab/routing';

// The Overview tab's `journeys` URL. The route has no children, so it matches the tab alone; every
// sibling tab has its own `overview_` route with its own forward.
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview',
)({
  component: JourneysTransactionalOverviewIndexHandoff,
});
